/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { TASK } from "./types";

export const nodeDisplayOptions = [
  {
    text: TASK.REBOOT.NAME,
    value: TASK.REBOOT.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: "Refresh",
    value: "RefreshFullDevice",
    permissionRequired: "manage_sn"
  },
  {
    text: "Delete",
    value: "Delete",
    permissionRequired: "manage_topology"
  },
  {
    text: "Refresh",
    value: "DasDiscoveryRefresh",
    permissionRequired: "manage_topology"
  },

  // {
  //   text: "Network settings",
  //   value: "Network settings",
  // },
  // {
  //   text: "Edit event notification settings",
  //   value: "Edit event notification settings",
  // },
  // {
  //   text: "Update firmware",
  //   value: "Update firmware",
  // },


];
export const deviceDrawerOptions = [
  {
    text: TASK.REBOOT.NAME,
    value: TASK.REBOOT.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: "Refresh",
    value: "RefreshFullDevice",
    permissionRequired: "manage_sn"
  },
   {
    text: "Delete",
    value: "Delete",
    permissionRequired: "manage_topology"
  },
  {
    text: "Refresh",
    value: "DasDiscoveryRefresh",
    permissionRequired: "manage_topology"
  },
  // {
  //   text: "View details",
  //   value: "View details",
  // },
  // {
  //   text: "Network settings",
  //   value: "Network settings",
  // },

  // {
  //   text: "More actions",
  //   value: "More actions",
  // },
];
export const nrCellOptions = [

  {
    text: TASK.NRCELLENABLE.NAME,
    value: TASK.NRCELLENABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: TASK.NRCELLDISABLE.NAME,
    value: TASK.NRCELLDISABLE.VALUE,
    permissionRequired: "manage_sn"
  },

];
export const lteCellOptions = [

  {
    text: TASK.LTECELLENABLE.NAME,
    value: TASK.LTECELLENABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: TASK.LTECELLDISABLE.NAME,
    value: TASK.LTECELLDISABLE.VALUE,
    permissionRequired: "manage_sn"
  },

];
export const radioNodeOptions = [

  {
    text: TASK.RADIONODEENABLE.NAME,
    value: TASK.RADIONODEENABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: TASK.RADIONODEDISABLE.NAME,
    value: TASK.RADIONODEDISABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: "Refresh",
    value: "PartialRefresh",
    permissionRequired: "manage_sn"
  },
  {
    text: "Reboot",
    value: TASK.REBOOTRADIONODE.VALUE,
    permissionRequired: "manage_sn"
  },

];

export const duOptions = [

  {
    text: TASK.DUENABLE.NAME,
    value: TASK.DUENABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: TASK.DUDISABLE.NAME,
    value: TASK.DUDISABLE.VALUE,
    permissionRequired: "manage_sn"
  },
  {
    text: "Refresh",
    value: "PartialRefresh",
    permissionRequired: "manage_sn"
  },
  {
    text: "Reboot",
    value: TASK.REBOOTRADIONODE.VALUE,
    permissionRequired: "manage_sn"
  },
]